// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"d8afac5a","771":"ccc63565","807":"b94a3082","815":"5c8ce7e8"}[chunkId] + ".chunk.css";
};